import {useState} from "react";
import {Controller, useForm} from "react-hook-form";
import {
    InputField,
    SelectUserAll
} from "~/components/Forms";
import {
    Button,
    Icon,
    Notification
} from "~/components";
import {useCan} from "~/hooks";

function BuilderLicenseSearchMobile({filter, onSearchChange}) {
    const can = {
        listAll: useCan('builderLicenseListAll'),
    };

    const [searchBar, setSearchBar] = useState(false);

    const {control, handleSubmit, formState: { errors }} = useForm({defaultValues: {}});

    const handleKeywordChange = (e) => {
        if (!onSearchChange) return;
        const newFilter = {
            ...filter,
            keyword: e.target.value,
            page: 1,
        };
        onSearchChange(newFilter);
    };

    const onSubmit = (data) => {
        if (!onSearchChange) return;
        const newFilter = {
            ...filter,
            keyword: data.keyword,
            userId: data.userId,
            page: 1,
        };
        setSearchBar(false);
        onSearchChange(newFilter);
    };

    return (
        <div className="search-bar">
            <div className="container">
                <div className="form">
                    <Button type="button" leftIcon={Icon.filter} onClick={() => setSearchBar(true)}>Lọc</Button>
                    <InputField
                        placeholder="Tên miền, tên website, license key"
                        onChange={handleKeywordChange}
                        defaultValue={filter.keyword}
                    />
                </div>
            </div>
            <Notification
                onClose={() => setSearchBar(false)}
                show={searchBar}
                title={'Tìm kiếm'}
                icon={Icon.search}>
                <form className="form form-mobile text-left" autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
                    <Controller control={control} name="keyword" render={({field}) => (
                        <InputField label="Tên miền, tên website, license key" errors={errors} {...field} />
                    )}/>
                    {can.listAll && (
                        <Controller control={control} name="userId" render={({field}) => (
                            <SelectUserAll
                                label="Người tạo"
                                placeholder="Chọn người tạo"
                                options={[{value:'', label:'Tất cả'}]}
                                errors={errors}
                                {...field}
                            />
                        )}/>
                    )}
                    <div className="form-actions">
                        <Button htmlType="submit" background>Tìm kiếm</Button>
                    </div>
                </form>
            </Notification>
        </div>
    );
}

export default BuilderLicenseSearchMobile;


